import { SyncWizardCheckIcon } from "./SyncWizardCheckIcon";

const LOADING_STEPS = [
  { label: "Connecting to destination board", threshold: 0 },
  { label: "Matching columns", threshold: 40 },
  { label: "Activating live share", threshold: 75 },
] as const;

export function SyncWizardLoadingView({ loadingProgress }: { loadingProgress: number }) {
  return (
    <div className="flex flex-col gap-7 justify-center items-center py-12">
      <div className="relative w-20 h-20">
        <svg className="w-20 h-20 -rotate-90" viewBox="0 0 80 80">
          <circle cx="40" cy="40" r="34" fill="none" stroke="#e6e9ef" strokeWidth="6" />
          <circle
            cx="40"
            cy="40"
            r="34"
            fill="none"
            stroke="#0073ea"
            strokeWidth="6"
            strokeLinecap="round"
            strokeDasharray={`${2 * Math.PI * 34}`}
            strokeDashoffset={`${2 * Math.PI * 34 * (1 - loadingProgress / 100)}`}
            style={{ transition: "stroke-dashoffset 0.04s linear" }}
          />
        </svg>
        <div className="flex absolute inset-0 justify-center items-center">
          <span className="text-[13px] font-semibold" style={{ color: "#0073ea" }}>
            {Math.round(loadingProgress)}%
          </span>
        </div>
      </div>

      <div className="text-center">
        <p className="text-[15px] font-semibold text-[#323338] mb-1">Setting up your share…</p>
        <p className="text-[12px] text-[#676879]">Connecting boards and syncing columns</p>
      </div>

      <div className="w-full max-w-xs h-1.5 rounded-full bg-[#e6e9ef] overflow-hidden">
        <div
          className="h-full rounded-full bg-[#0073ea]"
          style={{ width: `${loadingProgress}%`, transition: "width 0.04s linear" }}
        />
      </div>

      {LOADING_STEPS.map(({ label, threshold }) => (
        <div
          key={label}
          className="flex gap-2 items-center transition-opacity duration-300"
          style={{ opacity: loadingProgress >= threshold ? 1 : 0.25 }}
        >
          <div
            className="flex flex-shrink-0 justify-center items-center w-4 h-4 rounded-full transition-colors duration-300"
            style={{
              backgroundColor:
                loadingProgress >= threshold + 25
                  ? "#00c875"
                  : loadingProgress >= threshold
                    ? "#0073ea"
                    : "#e6e9ef",
            }}
          >
            {loadingProgress >= threshold + 25 ? (
              <SyncWizardCheckIcon size={8} />
            ) : loadingProgress >= threshold ? (
              <div className="w-1.5 h-1.5 rounded-full bg-white" />
            ) : null}
          </div>
          <span
            className="text-[12px]"
            style={{ color: loadingProgress >= threshold ? "#323338" : "#9da4b2" }}
          >
            {label}
          </span>
        </div>
      ))}
    </div>
  );
}
